export const getFilenamePrefix = (imageUrl) =>
  imageUrl.split(".").slice(0, -1).join(".");
